
import Invoices from '../../components/InvoicesComponent.vue';

export default {
  name: 'InvoicesMobile',
  components: { Invoices },
};
